<template>
  <div>
    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleSearch"
        @handleReset="handleClear"
      ></e-search>
    </div>
    <div class="container">
      <div class="handle-wrapper">
        <eui-btn type="secondary" @click="handleAdd">申请新增</eui-btn>
      </div>
      <TableList :table-data="tableData" :loading="loading" :table-label="tableLabel">
        <!-- 序号 -->
        <template #index="slotScope">
          <span>
            {{ (listQuery.pageNum - 1) * listQuery.pageSize + slotScope.scope.$index + 1 }}
          </span>
        </template>
        <!-- 商品名称 -->
        <template #brandName="slotScope">
          <span class="table-handle-btn" @click="goDetail(slotScope.scope.row)">
            {{ slotScope.scope.row.brandName }}
          </span>
        </template>
        <!-- 状态过滤 -->
        <template #brandAudit="slotScope">
          <span v-if="slotScope.scope.row.brandAuditStatus !== 3">
            {{ getBrandStatus(slotScope.scope.row.brandAuditStatus) }}
          </span>
          <el-tooltip v-else hover class="error" effect="dark" placement="top-start" style="cursor: pointer">
            <span slot="content">{{ slotScope.scope.row.refuseReason }}</span>
            <span>审核拒绝(拒绝原因)</span>
          </el-tooltip>
        </template>
        <!-- 图片 -->
        <template #brandImage="slotScope">
          <el-image
            v-if="slotScope.scope.row.brandImage"
            class="default-img"
            :src="slotScope.scope.row.brandImage"
            :preview-src-list="[slotScope.scope.row.brandImage]"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>
        <!-- 操作 -->
        <template #handle="slotScope">
          <span
            v-if="slotScope.scope.row.brandAuditStatus === 0 || slotScope.scope.row.brandAuditStatus === 3"
            class="table-handle-btn"
            @click="brandEdit(slotScope.scope.row)"
          >
            编辑
          </span>
          <span
            v-if="slotScope.scope.row.brandAuditStatus === 3"
            class="table-handle-btn"
            @click="brandDel(slotScope.scope.row)"
          >
            删除
          </span>
        </template>
      </TableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :page-size="listQuery.pageSize"
          :total="total"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="addVisible"
      width="30%"
      :before-close="handleAddClose"
      :append-to-body="true"
    >
      <span>您还没有申请通过的产品目录，请先申请产品目录再申请品牌</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleAddClose">取 消</el-button>
        <el-button type="primary" @click="productDirectoryApply">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import eSearch from '@/modules/projectA/components/common/e-search';
import TableList from '../../../components/common/e-table-list.vue';
import api from '../../../api/product';
import utils from '../../../utils/utils';
import { fieldList, listTypeInfo } from './componentsData.js';

console.log(api, 'asdas');
const listStatus = [
  {
    value: 0,
    label: '未提交审核',
  },
  {
    value: 1,
    label: '审核中',
  },
  {
    value: 2,
    label: '审核通过',
  },
  {
    value: 3,
    label: '审核拒绝',
  },
];
const brandAuditStatus = [
  {
    value: '',
    label: '全部',
  },
  {
    value: 0,
    label: '未提交审核',
  },
  {
    value: 1,
    label: '审核中',
  },
  {
    value: 2,
    label: '审核通过',
  },
  {
    value: 3,
    label: '审核拒绝',
  },
];
export default {
  components: {
    TableList,
    eSearch,
  },
  props: {},
  data() {
    return {
      listStatus,
      fieldList,
      listTypeInfo,
      brandAuditStatus,
      addVisible: false,
      listQuery: {
        brandName: '',
        brandNameEN: '',
        brandAuditStatus: '',
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      cloneListQuery: {},
      tableData: [],
      loading: false,
      tableLabel: [
        { label: '序号', align: 'center', slot: 'index', fixed: 'left', width: '80px' },
        { label: '品牌中文名称', param: 'brandName', align: 'center', slot: 'brandName' },
        { label: '品牌英文名称', param: 'brandNameEN', align: 'center' },
        {
          label: '品牌图片',
          slot: 'brandImage',
          param: 'brandImage',
          align: 'center',
          width: '100px',
        },
        {
          label: '审核状态',
          slot: 'brandAudit',
          param: 'brandAuditId',
          align: 'center',
        },
        { label: '操作', slot: 'handle', align: 'center', width: '120px' },
      ],
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
    };
  },
  computed: {},
  created() {
    const { cloneDeep } = utils;
    this.cloneListQuery = cloneDeep(this.listQuery);
    this.getList(this.query);
  },
  methods: {
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },
    getBrandStatus(brandAuditStatus) {
      const { label = '' } = this.listStatus.find((item) => item.value === brandAuditStatus) || {};
      return label;
    },
    brandEdit(row) {
      const { brandAuditId } = row;
      this.$router.push({ path: '/brandEdit', query: { brandAuditId } });
    },
    async getList(params) {
      const { querySupplyCompanyBrandAuditPage } = api;
      this.loading = true;
      const res = await querySupplyCompanyBrandAuditPage(params);
      this.loading = false;
      if (res.code === '200') {
        const { data } = res;
        this.tableData = [...data.records];
        this.total = data.total;
      }
      console.log(res);
    },
    brandDel(row) {
      this.$confirm('您确认要删除吗？不可恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const { brandAuditId = '' } = row;
          const { removeBrand } = api;
          const result = await removeBrand({ brandAuditId });
          if (result.code === '200') {
            this.getList(this.listQuery);
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    handleAddClose() {
      this.addVisible = false;
    },
    productDirectoryApply() {
      this.addVisible = false;
      this.$router.push({ path: '/productDirectoryApply' });
    },
    handleSearch(val) {
      this.listQuery = { ...val };
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    handleClear() {
      this.listQuery = {
        ...this.cloneListQuery,
      };
      this.getList(this.listQuery);
    },
    async handleAdd() {
      const { getCategoryListByAgreement } = api;
      const res = await getCategoryListByAgreement();
      if (!res.data) {
        this.addVisible = true;
        return;
      }
      this.$router.push({ path: '/brandProtocol' });
    },
    // 详情图
    goDetail(row) {
      const { brandAuditId } = row;
      this.$router.push({ path: '/brandDetail', query: { brandAuditId } });
    },
  },
};
</script>

<style scoped lang="scss">
.brand-manage {
  ::v-deep .el-image {
    width: 48px;
    height: 48px;
    display: block;
    font-size: 0;

    ::v-deep img {
      display: block;
      width: 100%;
      width: 100%;
    }
  }

  ::v-deep .el-message-box {
    border-radius: 0;
  }
}
</style>
